// Data export/import utilities for syncing between devices

/**
 * Export all app data to a JSON file
 */
export function exportData() {
  const data = {
    version: '1.0',
    exportedAt: new Date().toISOString(),
    users: localStorage.getItem('healthcues_users'),
    clients: localStorage.getItem('healthcues_clients'),
    currentUser: localStorage.getItem('healthcues_current_user'),
  };
  
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `healthcues-data-${Date.now()}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/**
 * Import app data from a JSON file
 */
export function importData(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);
        
        // Validate data structure
        if (!data.version || !data.users || !data.clients) {
          reject(new Error('Invalid data file format'));
          return;
        }
        
        // Merge or replace data
        if (data.users) localStorage.setItem('healthcues_users', data.users);
        if (data.clients) localStorage.setItem('healthcues_clients', data.clients);
        
        resolve({
          success: true,
          usersCount: JSON.parse(data.users || '[]').length,
          clientsCount: JSON.parse(data.clients || '[]').length,
        });
      } catch (error) {
        reject(error);
      }
    };
    
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsText(file);
  });
}
